import { translateOrderTypeItemName } from "../../../common/enums/orderTypes.enum";
export const allOrdersColumns = (t: any) => [
    {
      key: "Number",
      name: t('orders.columns.orderNumber'),
      fieldName: "number",
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "CreatedAt",
      name: t('orders.columns.orderDate'),
      fieldName: "createdAt",
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "Company",
      name: t('orders.columns.client'),
      fieldName: "company",
      minWidth: 150,
      maxWidth: 250,
      isResizable: true,
    },
    {
      key: "ReceptionPlace",
      name: t('orders.columns.receptionPlace'),
      fieldName: "receptionPlace",
      minWidth: 150,
      maxWidth: 400,
      isResizable: true,
    },
    {
      key: "Type",
      name: t('orders.columns.type'),
      fieldName: "type",
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      onRender: (item: any) => {
        const map: Record<string, string> = {
          "Pojazd": t('orders.typeValues.vehicle') as string,
          "Kontener": t('orders.typeValues.container') as string,
          "Tonaż": t('orders.typeValues.tonnage') as string,
          "Specjalne": t('orders.typeValues.special') as string,
        };
        return map[item.type] !== undefined ? map[item.type] : item.type;
      },
    },
    {
      key: "CurrentStatus",
      name: t('orders.columns.orderStatus'),
      fieldName: "status",
      minWidth: 100,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: any) => {
        const statusMap: Record<number, string> = {
          0: t('orders.statuses.placed') as string,
          1: t('orders.statuses.accepted') as string,
          2: t('orders.statuses.inProgress') as string,
          3: t('orders.statuses.completed') as string,
          4: t('orders.statuses.canceled') as string,
          5: t('orders.statuses.invoiced') as string,
        };
        return statusMap[item.statusId] !== undefined ? statusMap[item.statusId] : item.status;
      },
    },
    {
      key: "ContactPhone",
      name: t('orders.columns.phone'),
      fieldName: "contactPhone",
      minWidth: 50,
      maxWidth: 90,
      isResizable: true,
    },
    {
      key: "IsFromCuo",
      name: t('orders.columns.source'),
      fieldName: "isFromCuo",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "CuoOrderNumber",
      name: t('orders.columns.cuoOrderNumber'),
      fieldName: "cuoOrderNumber",
      minWidth: 80,
      maxWidth: 120,
      isResizable: true,
    },
    {
      key: "OrderTypeItem",
      name: t('orders.columns.vehicleType'),
      fieldName: "orderTypeItem",
      minWidth: 80,
      maxWidth: 120,
      isResizable: true,
      onRender: (item: any) => translateOrderTypeItemName(item.orderTypeItem, t),
    },

  ];